import createImmutableSelector from 'lib/immutable/selector'
import { IRegisterLayout } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getRegisterLayout = (state: any): IRegisterLayout => state.get('registerLayoutReducer')

export const registerLayoutSelector = createImmutableSelector(getRegisterLayout, (registerLayout) => registerLayout)
